import { ResourceType, type InventoryResource } from '@repo/api-gw-sdk';

/**
 * Checks if a resource uses native backup (e.g., FSx/EFS use AWS Backup in customer account)
 * @param resource The inventory resource to check
 * @returns true if the resource uses native backup
 */
export const isNativeBackupResource = (
  resource: InventoryResource
): boolean => {
  return (
    resource.resourceType === ResourceType.AwsFsx ||
    resource.resourceType === ResourceType.AwsEfs
  );
};

/**
 * Checks if all resources in a collection use native backup
 * @param entities Array of inventory resources
 * @returns true if all resources use native backup
 */
export const areAllNativeBackupResources = (
  entities: InventoryResource[]
): boolean => {
  return entities.length > 0 && entities.every(isNativeBackupResource);
};

/**
 * Checks if a selection contains both native and non-native backup resources
 * @param entities Array of inventory resources
 * @returns true if the selection is mixed (contains both native and non-native resources)
 */
export const hasMixedNativeBackupSelection = (
  entities: InventoryResource[]
): boolean => {
  const hasNative = entities.some(isNativeBackupResource);
  const hasNonNative = entities.some(
    (entity) => !isNativeBackupResource(entity)
  );
  return hasNative && hasNonNative;
};
